import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DishConfigurationState {
  dishSizeId: string | null
  dishToppingIds: string[]
  removedToppingIds: string[]
  guestNumber: string
  note: string
  discount: number
  setDishSizeId: (id: string | null) => void
  setDishToppingIds: (ids: string[]) => void
  setRemovedToppingIds: (ids: string[]) => void
  setGuestNumber: (guestNumber: string) => void
  setNote: (note: string) => void
  setDiscount: (discount: number) => void
  reset: () => void
}

export const useDishConfigurationStore = create<DishConfigurationState>()(
  persist(
    set => ({
      dishSizeId: null,
      dishToppingIds: [],
      removedToppingIds: [],
      guestNumber: '',
      note: '',
      discount: 0,
      setDishSizeId: id => set({ dishSizeId: id }),
      setDishToppingIds: ids => set({ dishToppingIds: ids }),
      setRemovedToppingIds: ids => set({ removedToppingIds: ids }),
      setGuestNumber: guestNumber => set({ guestNumber }),
      setNote: note => set({ note }),
      setDiscount: discount => set({ discount }),
      reset: () =>
        set({
          dishSizeId: null,
          dishToppingIds: [],
          removedToppingIds: [],
          note: '',
          discount: 0
        })
    }),
    {
      name: 'dish-configuration-storage'
    }
  )
)
